module.exports = __webpack_public_path__ + "static/media/me.b83fa12a.png";